import {Pipe, PipeTransform} from "@angular/core";
import {Risk} from "../../store/state/order.state";
import {TranslateService} from "@ngx-translate/core";
import {Observable, of} from "rxjs";
import {map} from "rxjs/operators";

@Pipe({
    name: 'riskName',
    standalone: false
})
export class RiskNamePipe implements PipeTransform {

	private translations$;

	constructor(private translateService: TranslateService) {
		this.translations$ = this.translateService.get([
			'pricing-details.risk-neuter',
			'pricing-details.risk-female',
			'pricing-details.risk-male'
		]);
	}

	transform(risk: Risk, gender: string): Observable<string> {
		const key = `pricing-details.risk-${gender}`;
		return risk != null ? this.translations$.pipe(map(translations => translations[key][risk.toLowerCase()])) : of("");
	}
}
